import React from 'react';

import { ManageContractsApp } from '../contractManagementContext';
import OldAddress from '../sections/OldAddress';
import EndDate from '../sections/EndDate';
import CreateNewContract from '../sections/CreateNewContract';
import TerminateLedgerAddress from '../sections/TerminateLedgerAddress';
import MoveContinue from './MoveContinue';
import MoveTerminate from './MoveTerminate';

export const MoveBase: React.FunctionComponent = () => {
  const { oldContract, createNewContract } = ManageContractsApp.useState();

  return (
    <>
      <OldAddress />
      {oldContract && (
        <>
          <EndDate />
          <CreateNewContract />
          {createNewContract !== undefined && <TerminateLedgerAddress />}
          {createNewContract === true && <MoveContinue />}
          {createNewContract === false && <MoveTerminate />}
        </>
      )}
    </>
  );
};

export default MoveBase;
